export interface Endpoint {
    serviceUrl: string;
    siteUrl: string;
    name: string;
}

export enum Environment {
    localdev = 'localdev',
    beta = 'beta',
    gamma = 'gamma',
    prod = 'prod',
}

export const EndpointMap: {[key in keyof typeof Environment]: Endpoint} = {
    localdev: {
        serviceUrl: 'http://localdev.caracal.proserve.aws.a2z.com:3000',
        siteUrl: 'https://survey.beta.caracal.proserve.aws.a2z.com',
        name: 'localdev',
    },
    beta: {
        serviceUrl: 'https://data-collection-service.beta.caracal.proserve.aws.a2z.com',
        siteUrl: 'https://survey.beta.caracal.proserve.aws.a2z.com',
        name: 'beta'
    },
    gamma: {
        serviceUrl: 'https://data-collection-service.gamma.caracal.proserve.aws.a2z.com',
        siteUrl: 'https://survey.gamma.caracal.proserve.aws.a2z.com',
        name: 'gamma'
    },
    prod: {
        serviceUrl: 'https://service.inquire.accelerate.amazonaws.com',
        siteUrl: 'https://inquire.accelerate.amazonaws.com',
        name: 'prod',
    }
};

export function GetEndpoint(environment: Environment): Endpoint {
    const endpoint: Endpoint = EndpointMap[environment];
    if (!endpoint) {
        throw new Error(`No endpoint for environment: ${environment}`);
    }
    return endpoint;
}
